var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,37h-2.221c2.398-2.345,3.946-5.542,4.175-9.096C48.256,27.456,50,25.43,50,23c0-2.414-1.721-4.434-4-4.899V8   c0-3.86-3.141-7-7-7H25c-3.859,0-7,3.14-7,7v10.101c-2.279,0.465-4,2.484-4,4.899c0,2.43,1.744,4.456,4.046,4.904   c0.229,3.554,1.777,6.751,4.175,9.096H20c-4.963,0-9,4.037-9,9v16c0,0.553,0.447,1,1,1h40c0.553,0,1-0.447,1-1V46   C53,41.037,48.963,37,44,37z M43.508,19.747L39.382,28H33v-3h-2v3h-6.382l-4.126-8.253C22.517,19.108,24,17.234,24,15v-1.93   c0-1.142,0.929-2.07,2.07-2.07c0.41,0,0.808,0.12,1.148,0.348l0.562,0.375c2.508,1.671,5.93,1.671,8.438,0l0.563-0.375   C37.122,11.12,37.52,11,37.93,11c1.142,0,2.07,0.929,2.07,2.07V15C40,17.234,41.483,19.108,43.508,19.747z M39,30v6.727   C37.027,38.151,34.614,39,32,39s-5.027-0.849-7-2.273V30H39z M32,41c2.135,0,4.151-0.494,5.964-1.352C37.639,42.653,35.09,45,32,45   s-5.639-2.347-5.964-5.352C27.849,40.506,29.865,41,32,41z M41,34.911v-5.675l3-6V27C44,30.032,42.861,32.796,41,34.911z M48,23   c0,1.302-0.839,2.402-2,2.816v-5.631C47.161,20.598,48,21.698,48,23z M25,3h14c2.757,0,5,2.243,5,5v9.816   c-1.161-0.414-2-1.514-2-2.816v-1.93C42,10.826,40.174,9,37.93,9c-0.808,0-1.588,0.236-2.258,0.684l-0.562,0.375   c-1.848,1.231-4.371,1.231-6.219,0l-0.562-0.375C27.658,9.236,26.878,9,26.07,9C23.826,9,22,10.826,22,13.07V15   c0,1.302-0.839,2.402-2,2.816V8C20,5.243,22.243,3,25,3z M16,23c0-1.302,0.839-2.402,2-2.816v5.631C16.839,25.402,16,24.302,16,23z    M20,27v-3.764l3,6v5.675C21.139,32.796,20,30.032,20,27z M51,61h-5V50h-2v11H20V50h-2v11h-5V46c0-3.859,3.141-7,7-7h4   c0,4.411,3.589,8,8,8s8-3.589,8-8h4c3.859,0,7,3.141,7,7V61z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 7,
    x: 34,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 7,
    x: 23,
    y: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,23c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S28.327,23,27.5,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,23c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S37.327,23,36.5,23z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 10,
    x: 27,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 6,
    x: 29,
    y: 36
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.8b650b9a3ae16b03b6af1be1f3f97e80.svg";
export { ForwardRef as ReactComponent };